// Category configuration shared across the app.
// Backend stores category as: restaurant | bar | hotel | rental | mechanic | car_sale | car_rental
// URL slugs are French-friendly.

export const CATEGORIES = {
  restaurant: {
    slug: "restaurants",
    label: "Restaurants",
    singular: "Restaurant",
    subtypeLabel: "Type de cuisine",
    subtypePlaceholder: "ex: Tchadienne, Libanaise, Italienne",
    icon: "Utensils",
    color: "#C8A04D",
    description: "Tables traditionnelles, fast-food et cuisines du monde.",
  },
  bar: {
    slug: "bars",
    label: "Bars",
    singular: "Bar",
    subtypeLabel: "Ambiance",
    subtypePlaceholder: "ex: Lounge, Pub, Karaoké, Terrasse",
    icon: "Wine",
    color: "#6B3030",
    description: "Bars, lounges et lieux de sortie.",
  },
  hotel: {
    slug: "hotels",
    label: "Hôtels",
    singular: "Hôtel",
    subtypeLabel: "Type d'établissement",
    subtypePlaceholder: "ex: Boutique, Affaires, Auberge",
    icon: "BedDouble",
    color: "#1E3A5F",
    description: "Hôtels, auberges et résidences de tourisme.",
  },
  rental: {
    slug: "locations",
    label: "Locations",
    singular: "Maison à louer",
    subtypeLabel: "Type de logement",
    subtypePlaceholder: "ex: Villa, Appartement, Studio",
    icon: "Home",
    color: "#2D5238",
    description: "Maisons, villas et appartements à louer.",
  },
  mechanic: {
    slug: "mecaniciens",
    label: "Mécaniciens",
    singular: "Mécanicien",
    subtypeLabel: "Spécialités",
    subtypePlaceholder: "ex: Toyota, Hyundai, Diesel",
    icon: "Wrench",
    color: "#0F0F0F",
    description: "Garages, mécaniciens et tôlerie.",
  },
  car_sale: {
    slug: "voitures-vente",
    label: "Vente de voitures",
    singular: "Voiture à vendre",
    subtypeLabel: "Marque",
    subtypePlaceholder: "ex: Toyota, Mercedes, Hyundai",
    icon: "Car",
    color: "#8B6F23",
    description: "Véhicules neufs et d'occasion à acheter.",
  },
  car_rental: {
    slug: "voitures-location",
    label: "Location de voitures",
    singular: "Voiture en location",
    subtypeLabel: "Marque",
    subtypePlaceholder: "ex: Toyota, Hyundai",
    icon: "CarFront",
    color: "#B89968",
    description: "Voitures à louer avec ou sans chauffeur.",
  },
  travel_agency: {
    slug: "agences-de-voyages",
    label: "Agences de voyages",
    singular: "Agence de voyages",
    subtypeLabel: "Services",
    subtypePlaceholder: "ex: Vol & hôtel, Visa, Pèlerinage, Safari",
    icon: "Plane",
    color: "#2A8C8C",
    description: "Vols, séjours, visas, pèlerinages et voyages organisés.",
  },
};

export const CATEGORY_ORDER = [
  "restaurant",
  "bar",
  "hotel",
  "rental",
  "mechanic",
  "car_sale",
  "car_rental",
  "travel_agency",
];

// Re-export Chad city/region data from the central chad.js module
export { PRIORITY_CITIES, OTHER_CITIES, ALL_CITIES, CHAD_REGIONS, MAJOR_CITIES } from "./chad";

export function getCategoryBySlug(slug) {
  return Object.entries(CATEGORIES).find(([_, c]) => c.slug === slug) || null;
}

export function getCategoryKey(slug) {
  const entry = getCategoryBySlug(slug);
  return entry ? entry[0] : null;
}
